import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export function KpiCard({ title, value, subtitle, icon: Icon, trend, trendDirection, className }) {
  return (
    <Card
      data-testid="kpi-card"
      className={cn(
        'relative overflow-hidden border-border/60 bg-card transition-[border-color,box-shadow,transform] duration-200 hover:border-border/80 hover:shadow-[var(--vrs-shadow-elev-1)] hover:-translate-y-[1px]',
        className
      )}
    >
      <CardContent className="p-5 md:p-6">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <p className="text-xs font-semibold tracking-wide uppercase text-muted-foreground">
              {title}
            </p>
            <p className="text-2xl md:text-3xl font-semibold tracking-tight font-mono tabular-nums text-foreground">
              {value}
            </p>
            {subtitle && (
              <p className="text-xs text-muted-foreground">{subtitle}</p>
            )}
            {trend && (
              <p
                className={cn(
                  'text-xs font-medium',
                  trendDirection === 'up' ? 'text-vrs-green' : trendDirection === 'down' ? 'text-vrs-red' : 'text-muted-foreground'
                )}
              >
                {trend}
              </p>
            )}
          </div>
          {Icon && (
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 border border-primary/20">
              <Icon className="h-5 w-5 text-primary" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
